import firebase from 'firebase/app';
import 'firebase/auth';
import { handleError } from './utils';

export const login = ({ email, password, rememberMe }) => handleError(async (dispatch, getState, { api }) => {
  dispatch({ type: 'BEGIN_OPERATION' });
  await api.loginFirebase(email, password, rememberMe);
}, 'There was a problem when trying to sign in');

export const googleLogin = () => handleError(async (dispatch, getState, { api }) => {
  const provider = new firebase.auth.GoogleAuthProvider();
  api.oauth(provider);
}, 'There was a problem when trying to sign in');

export const facebookLogin = () => handleError(async (dispatch, getState, { api }) => {
  const provider = new firebase.auth.FacebookAuthProvider();
  provider.addScope('public_profile');
  provider.addScope('email');
  api.oauth(provider);
}, 'There was a problem when trying to sign in');

export const signUp = (signUpData) => handleError(async (dispatch, getState, { api }) => {
  dispatch({ type: 'BEGIN_OPERATION' });
  await api.signUp(signUpData);
  return true;
}, 'There was a problem when trying to sign up');

export const logout = (history, route) => handleError(async (dispatch, getState, { api }) => {
  api.logout();
  history.push(route);
});

export const forgotPassword = ({ email }) => handleError(async (dispatch, getState, { api }) => {
  dispatch({ type: 'BEGIN_OPERATION' });
  api.forgotPassword(email);
}, 'There was a problem when trying to reset password');

export const authPlugin = (token, refreshToken, port) => handleError(async (dispatch, getState, { api }) => {
  const response = await api.authPlugin(token, refreshToken, port);
  return response;
}, 'There was a problem when connect with the plugin', { silent: true });
